module.exports = __webpack_public_path__ + "img/DGX.22ccf83d.svg";